export default "__VITE_ASSET__8139f829__"